/**
 * @description: Notification Service.
 * @requires {Object} baseSixtyFour Polyfill to decode b64 strings.
 */
function notificationService(baseSixtyFour) {

  return {

    /**
     * @description: Decodes a base64 MAC token into a MAC HEX String.
     *
     * @param MacToken {String} URL passed.
     * @returns {String} Decoded HEX String.
     */
    decodeMAC: (MacToken => baseSixtyFour.urlDecodeToHex(MacToken)),

    /**
     * @description: Checks if there is a valid session.
     *
     * @param expiary {number} the current session timestamp.
     * @returns {boolean} true if the session is invalid.
     */
    isNewSessionNeeded: (expiary) => {

      // Transform the Date().getTime() from milliseconds to seconds.
      const now = Math.floor(new Date().getTime() / 1000);

      // Threshold in seconds when the session must be renewed.
      const threshold = 30;

      return ((parseInt(expiary, 10) - now) < threshold);

    }
  };

}

export default notificationService;



// WEBPACK FOOTER //
// ./src/services/notification.service.js